import useLeadDocuments from "../../data/useLeadDocuments";
import { ILead } from "../../models/Lead";

export default function CarCollectedImage({ lead }: { lead: ILead }) {
  // const { leadDocuments } = useLeadDocuments(lead.id);

  let frontImage = lead.documents?.find(img => img.fileName?.includes("front"));

  if (!frontImage) {
    frontImage = lead.documents?.find(img => img.contentType === "image/jpeg");
  }

  // console.log(frontImage);
  return (
    <span className="flex justify-center relative" >
      {frontImage ? (
        <>
          <img
            className="w-32 h-20 object-contain"
            src={`data:${frontImage.contentType};base64, ${frontImage.thumbnail}` || ""}
          />
        </>
      ) : (
        "N/A"
      )}
    </span>
  )
}